export default "__VITE_ASSET__BnwMavsw__"